import React, { useState, useContext } from 'react'
import {
  Modal,
  Spin,
  Input,
  DatePicker,
  Row,
  Col,
  message,
  Checkbox,
} from 'antd'
import moment from 'moment'
import { UnitSelectionContext, ErrorContext } from 'context'
import * as R from 'ramda'
const RiveSystemRegionGroupModal = ({
  riverList,
  hide,
  data = {},
  updateTask,
  createTask,
  isLoading = false,
  // unitNameMap,
  list,
  // popModal,
}) => {
  const { setVisibleUnitSelection } = useContext(UnitSelectionContext)
  const { setError } = useContext(ErrorContext)
  const processing = isLoading
  const { isNew = false } = data
  const [baseData, setBaseData] = useState(
    isNew
      ? {
          ...data,
          effectiveDate: moment(),
          region: undefined,
          river: data.isDuplicate ? data.river || [] : [],
        }
      : { ...data, effectiveDate: moment(data.effectiveDate, 'YYYY-MM-DD') }
  )

  const [selectedRiver, setSelectedRiver] = useState(baseData.river)

  // useEffect(() => {
  //   setVisibleUnitSelection(true)
  //   setSelectedRiver(selectedRiver)
  // }, [selectedRiver, setVisibleUnitSelection])

  const onOk = () => {
    const finalData = {
      ...baseData,
      effectiveDate: baseData.effectiveDate.format('YYYY-MM-DD'),
      river: selectedRiver,
    }

    if (finalData.region === undefined || finalData.region.trim() === '') {
      message.error('Group name must be entered.')
    } else if (finalData.river.length === 0) {
      message.error('There must be at least one River assigned to the group.')
    } else if (
      isNew &&
      list.find(
        l =>
          l.region.toLocaleLowerCase() === finalData.region.toLocaleLowerCase()
      )
    ) {
      message.error('Same Group Name found, Plase rename the Group Name')
    } else {
      setVisibleUnitSelection(false)
      if (isNew) {
        createTask(finalData).fork(e => setError(e, () => hide(null)), hide)
      } else {
        updateTask(finalData).fork(e => setError(e, () => hide(null)), hide)
      }
    }
  }
  const onRiverChanged = (checked, river) => {
    setSelectedRiver([...R.without(river, selectedRiver)])
    if (checked) setSelectedRiver([...selectedRiver, river])
  }

  return (
    <Modal
      title={isNew ? 'New Region Group' : 'Edit Region Group'}
      width="80vw"
      visible
      onOk={onOk}
      okText="Save"
      onCancel={() => {
        hide()
        setVisibleUnitSelection(false)
      }}
      centered
      bodyStyle={{ maxHeight: '80vh' }}
      maskClosable={false}
      okButtonProps={{ loading: processing }}
      cancelButtonProps={{ loading: processing }}
      afterClose={() => setVisibleUnitSelection(false)}
      destroyOnClose
      zIndex={800}
    >
      <Spin spinning={processing}>
        <Row gutter={12}>
          <Col span={3}>
            <label>Group Name : </label>
          </Col>
          <Col span={10}>
            <Input
              disabled={!isNew}
              maxLength={50}
              placeholder="Enter Group Name"
              value={baseData.region}
              onChange={e =>
                setBaseData({ ...baseData, region: e.target.value })
              }
            />
          </Col>
          <Col span={3}>
            <label>Effective Date : </label>
          </Col>
          <Col span={8}>
            <DatePicker
              disabled={!isNew}
              allowClear={false}
              format="MM/DD/YYYY"
              value={baseData.effectiveDate}
              onChange={value =>
                setBaseData({ ...baseData, effectiveDate: value })
              }
            />
          </Col>
        </Row>
        <div
          style={{
            border: '1px solid #eee',
            borderRadius: '5px',
            alignContent: 'flex-start',
            maxHeight: '45vh',
            overflow: 'auto',
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
            display: 'flex',
            margin: '10px',
          }}
        >
          {riverList.map(r => (
            <Checkbox
              style={{
                height: '30px',
                overflow: 'hidden',
                flex: '0 0 200px',
                marginLeft: '6px',
              }}
              key={r}
              checked={selectedRiver.includes(r)}
              onChange={e => onRiverChanged(e.target.checked, r)}
            >
              {r}
            </Checkbox>
          ))}
        </div>
        {/* <UnitSelection
          units={availableUnits}
          selectedUnits={selectedUnits}
          // setSelectedUnits={setSelectedUnits}
          utilityNameMap={utilityNameMap}
          renderBottomControls={() => <></>}
          onConfirm={setSelectedUnits}
          setCheckedItems={setSelectedUnits}
          checked={selectedUnits}
          unitTypeCode={props.unitTypeCode}
          unitGroups={props.unitGroups}
        /> */}
      </Spin>
    </Modal>
  )
}
export default RiveSystemRegionGroupModal
